const integer = new Intl.NumberFormat('pt-BR')
const percent = new Intl.NumberFormat('pt-BR', { style: 'percent', maximumFractionDigits: 1 })

/** Micro-dólares em US$. Centavo some em custo de IA, então até 4 casas abaixo de 1 dólar. */
export function formatUsd(micros: number): string {
    const usd = micros / 1_000_000
    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: Math.abs(usd) < 1 ? 4 : 2,
    }).format(usd)
}

export function formatBrl(micros: number, usdBrlRate: number): string {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(
        (micros / 1_000_000) * usdBrlRate
    )
}

/** Milésimos de centavo (unidade do débito em créditos) em R$. */
export function formatMilliCentsBrl(milliCents: number): string {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(
        milliCents / 100_000
    )
}

/** Créditos com até duas casas: uma resposta do atendente gasta menos de um crédito. */
export function formatCredits(value: number): string {
    return new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 }).format(value)
}

export function formatInteger(value: number): string {
    return integer.format(value)
}

/** Tokens em mil/milhão: a coluna precisa caber no celular. */
export function formatTokens(value: number): string {
    if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1).replace('.', ',')} mi`
    if (value >= 1_000) return `${(value / 1_000).toFixed(1).replace('.', ',')} mil`
    return integer.format(value)
}

export function formatPercent(part: number, whole: number): string {
    return whole > 0 ? percent.format(part / whole) : '—'
}

export function formatMinutes(seconds: number): string {
    return `${integer.format(Math.round(seconds / 60))} min`
}
